import DiscountbenefitPaliSheet from "./DiscountbenefitPaliSheet";

export default class DiscountBenefitSheet {
  public static open(target: HTMLElement, benefitId: string, dresonRule: string, variationId: string) {
    if (!target || !(target instanceof HTMLElement || !benefitId)) return;
    DiscountbenefitPaliSheet.open(benefitId, dresonRule, variationId);
  }
}
